import { render, staticRenderFns } from "./ChatgptTrain.vue?vue&type=template&id=f609884a"
import script from "./ChatgptTrain.vue?vue&type=script&lang=js"
export * from "./ChatgptTrain.vue?vue&type=script&lang=js"
import style0 from "./ChatgptTrain.vue?vue&type=style&index=0&id=f609884a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports